define('SuiteDynamics.CategoryFAQ.View', [
    'SCView',
    'suitedynamics_category_faq.tpl',
    'underscore'
], function CategoryFAQViewModule(
    SCViewComponent,
    suitedynamicsCategoryFaqTpl,
    _
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function CategoryFAQView(options) {
        SCView.call(this);

        this.template = suitedynamicsCategoryFaqTpl;
        this.getFaqs = options.getFaqs;
    }

    CategoryFAQView.prototype = Object.create(SCView.prototype);
    CategoryFAQView.prototype.constructor = CategoryFAQView;

    CategoryFAQView.prototype.getContext = function () {
        
        return {
            faqs: this.getFaqs ? this.getFaqs() : []
        };
    };

    return CategoryFAQView;
});
